import React, { useState } from 'react';
import { ProviderParams } from '../models/react';
import { OmniMessage, OmniMessageType, OmniPageContextType, BrowserEngagementStatus } from '../models/omnipage';
import { usePushNotificationContext } from './push-notification'

const OmniPageContext = React.createContext<OmniPageContextType | undefined>(undefined);
const channel = new BroadcastChannel('omnipage');
const id = getTabId()
export function useOmniPageContext() {
    return React.useContext(OmniPageContext);
}


function getTabId() {
    const tabid = sessionStorage.getItem("tabId")
    if (tabid) return tabid;
    const newTabId = generateRandomId(8)
    sessionStorage.setItem("tabId", newTabId)
    return newTabId
}


function generateRandomId(length: number) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

export default function OmniPageProvider({ children }: ProviderParams) {
    const PushNotificationContext = usePushNotificationContext()
    if (!PushNotificationContext) throw new Error('Missing Notification context');

    let browserEngagementsStr = localStorage.getItem("activeEngagements")
    let browserEngagementsDefault: BrowserEngagementStatus = createEngagementStatus(id)
    if (browserEngagementsStr != null) {
        browserEngagementsDefault = JSON.parse(browserEngagementsStr)
    }
    let [browserEngagements, setBrowserEngagements] = useState(browserEngagementsDefault || createEngagementStatus(id))

    function setTabEngagement() {
        if (browserEngagements.id === id) {
            let activeEngagement = createEngagementStatus(id, true)
            localStorage.setItem('activeEngagements', JSON.stringify(activeEngagement))
            setBrowserEngagements(activeEngagement)
            sendMessage(OmniMessageType.STARTING_ENGAGEMENT)
        }
    }
    function refreshTabEngagement() {
        let browserEngagementsStr = localStorage.getItem("activeEngagements")
        let browserEngagementsDefault: BrowserEngagementStatus
        if (browserEngagementsStr != null) {
            browserEngagementsDefault = JSON.parse(browserEngagementsStr)
            setBrowserEngagements(browserEngagementsDefault)
        }
        else {
            browserEngagementsDefault = createEngagementStatus(id)
            setBrowserEngagements(browserEngagementsDefault)
        }
    }
    function isTabActive(): boolean {
        refreshTabEngagement()
        return browserEngagements.active && browserEngagements.id !== id
    }
    function removeTabEngagement() {
        if (browserEngagements.id === id) {
            localStorage.removeItem('activeEngagements')
            setBrowserEngagements(createEngagementStatus(id, false))
            sendMessage(OmniMessageType.SHUTTING_DOWN_ENGAGEMENT)
        }

    }
    function existActiveEngagement() {
        let activeEngagements: string[] = JSON.parse(sessionStorage.getItem("ccaasActiveEngagements") || "[]")
        return activeEngagements[0]
    }

    function sendMessage(message_type: OmniMessageType) {

        let message: OmniMessage = {
            tab: id,
            type: message_type

        }
        channel.postMessage(JSON.stringify(message))
    }
    channel.onmessage = function (event) {
        const data: OmniMessage = JSON.parse(event.data)
        if (data.tab === id) return;
        if (data.type === OmniMessageType.SHUTTING_DOWN_ENGAGEMENT) {
            refreshTabEngagement()
        }
        if (data.type === OmniMessageType.STARTING_ENGAGEMENT) {
            refreshTabEngagement()
        }
        if (data.type === OmniMessageType.NOTIFY_TAB) {
            if (existActiveEngagement()) {
                PushNotificationContext?.sendPushNotification("Conversation Active", "Click here to go back to our conversation", "Conversation back: "+generateRandomId(8), () => {
                    console.log("notification sent")
                })
            }
        }
    };

    function engagementIsValid(): boolean {
        refreshTabEngagement()
        if (browserEngagements.active) {
            const now = new Date()
            const diffInSecs = Math.round((now.getTime() - new Date(browserEngagements.updated).getTime()) / 1000)
            if (diffInSecs > 600) {
                return false;
            }
            sendMessage(OmniMessageType.NOTIFY_TAB)
        }
        return browserEngagements.active;

    }


    return (
        <OmniPageContext.Provider value={{ engagementIsValid, setTabEngagement, removeTabEngagement, isTabActive }}>
            {children}
        </OmniPageContext.Provider>
    );
}


function createEngagementStatus(id: string, active: boolean = false): BrowserEngagementStatus {
    return {
        active: active,
        id: id,
        updated: new Date()
    }
}